import { createRoot } from 'react-dom/client';
import App from './app.jsx';

createRoot(document.getElementById('root')).render(<App />);
